import { Box, Flex, Text } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { DotDotDot } from 'components/common/layout/dot-dot-dot';
import { VideoPlaceholder } from 'components/common/video/placeholder';
import { CommonVideoPlayerHoC } from 'components/common/video/player';
import { VideoPlayerType } from 'enums/video-player.enums';
import { t } from 'i18next';
import { VideoHelper } from 'lib_ts/classes/video.helper';
import { IVideoPlayback } from 'lib_ts/interfaces/i-video';
import { useEffect, useMemo, useState } from 'react';
import { useVideosStore } from 'stores/use-videos-store';

// only used to play the entire video
export const VideoLibrarySidebarPreview = () => {
  const selectedVideo = useVideosStore((s) => s.selectedVideo);

  const [playback, setPlayback] = useState<IVideoPlayback>();

  useEffect(() => {
    if (!selectedVideo?._id) {
      return;
    }

    useVideosStore
      .getState()
      .lazyLoadPlayback(selectedVideo._id)
      .then((result) => setPlayback(result));
  }, [selectedVideo?._id]);

  const aspectRatio = useMemo(
    () =>
      selectedVideo ? VideoHelper.getAspectRatio(selectedVideo) : undefined,
    [selectedVideo]
  );

  if (!selectedVideo) {
    return null;
  }

  return (
    <ErrorBoundary identifier="VideoLibrarySidebarPreview">
      <Flex direction="column" gap="2">
        <Text>{t('videos.video-preview')}</Text>

        <Box>
          {playback ? (
            // player can end up in a stale-playback state without the key
            <CommonVideoPlayerHoC
              key={playback.video.url}
              playback={playback}
              type={VideoPlayerType.Pitcher}
            />
          ) : (
            <VideoPlaceholder aspectRatio={aspectRatio}>
              <DotDotDot label="common.loading" />
            </VideoPlaceholder>
          )}
        </Box>
      </Flex>
    </ErrorBoundary>
  );
};
